module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product bps",
    class: {
      contrasted: _vm.isPageContrasted, fontBigger: _vm.isFontBigger
    }
  }, [_c('header', {
    staticClass: "page-header",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.lang === 'pl') ? _c('div', {
    staticClass: "heading-text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("Bird Protection System - przełomowa technologia ochrony ptaków na farmach wiatrowych, pozwalająca na zrównoważony rozwój energetyki ")]) : _vm._e(), _vm._v(" "), (_vm.lang !== 'pl') ? _c('div', {
    staticClass: "heading-text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("Bird Protection System - a disruptive technology for bird protection at wind farms, allowing for sustainable wind and power development")]) : _vm._e(), _vm._v(" "), _c('p', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "100"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "line",
    attrs: {
      "data-aos": "zoom-in-left",
      "data-aos-delay": "150"
    }
  }), _vm._v(" "), _c('p', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "200"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "btn-hover"
  }, [_c('router-link', {
    staticClass: "btn orange",
    attrs: {
      "to": "/products/farms/presentation",
      "data-aos": "fade-up",
      "data-aos-delay": "250"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('component.watchPresentation'))), _c('span')])], 1), _vm._v(" "), _c('div', {
    staticClass: "btn-hover",
    on: {
      "click": function($event) {
        _vm.$modal.show('video-static')
      }
    }
  }, [_c('div', {
    staticClass: "btn orange",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "250"
    }
  }, [_vm._v(_vm._s(_vm.$t('component.watchVideo'))), _c('span')])])])]), _vm._v(" "), _c('div', {
    staticClass: "why-us-solution",
    attrs: {
      "id": "top"
    }
  }, [_c('div', {
    staticClass: "elements"
  }, [_c('div', {
    staticClass: "element bps clearfix"
  }, [_c('div', {
    staticClass: "text-box"
  }, [(_vm.lang === 'pl') ? _c('ul', [_vm._m(0), _vm._v(" "), _vm._m(1)]) : _vm._e(), _vm._v(" "), (_vm.lang !== 'pl') ? _c('ul', [_vm._m(2), _vm._v(" "), _vm._m(3)]) : _vm._e()])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("\n              Celem projektu jest opracowanie w pełni dostosowanego do potrzeb rynku rozwiązania do wykrywania  i odstraszania ptaków w okolicy farm wiatrowych.  Ze względu na wysokie ryzyko kolizji z ptakami, niektóre z istniejących farm są zmuszone do wyłączenia turbin. Opracowaliśmy pierwotną wersję systemu do wykrywania ptaków i wprowadzania odpowiedniej reakcji, która sprawdziła się w działaniu. Obecnie w pełni rozumiemy problemy dotyczące awifauny na farmach wiatrowych i pragniemy opracować w pełni automatyczne i bardzo precyzyjne rozwiązanie, które w znacznym stopniu ograniczy liczbę kolizji, a także straty właścicieli turbin. Opracowane w ramach projektu rozwiązanie będzie charakteryzować się:\n            "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" 1.  Zwiększoną dokładnością klasyfikacji obiektów oraz minimalną liczbą fałszywych detekcji. W tym celu zastosujemy samouczące się algorytmy bazujące na sztucznej inteligencji oraz paradygmacie Big Data w rozproszonym systemie IoT.\n                  "), _c('br'), _vm._v(" 2. Wysoką niezawodnością systemu. Nowa metoda autodiagnostyki i in-situ auto-kalibracji umożliwi na skrócenie czasu instalacji oraz ich długą żywotność.\n                  "), _c('br'), _vm._v(" 3. Otwartą elastyczną architekturą systemu, która pozwoli na łatwe skalowanie produktu i jego kastomizację.\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "text"
  }, [_c('br'), _c('br'), _c('br'), _vm._v("\n                Wartosć projektu:"), _c('br'), _vm._v("\n                3 866 129,08PLN\n                  "), _c('br'), _c('br'), _vm._v("\n                  Dofinansowanie projektu z UE:"), _c('br'), _vm._v("\n                2 890 434.62PLN\n                  "), _c('br'), _c('br'), _vm._v("\n                  Okres realizacji: 01.09.2021 – 31.08.2023\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("\n                The aim of the project is to develop solutions to meet the needs of the bird advisory and deterrent market in the vicinity of wind farms. We have noticed that wind farms development poses a threat to local environment, especially avifauna. Even some of the existing power plants have been obliged to shut down turbines due to the high risk of collision with birds. We developed the initial detection and deterrence system that has been proved to be of high value. Currently, we fully understand the problems regarding avifauna on wind farms and wish to develop a fully automatic and very precise solution that will largely reduce the number of collisions, as well as wind farm owners’ losses.\nIn this project our goal is to develop a market-tailored bird protection solution that will be characterised by:\n                "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" 1.  Improved object classification accuracy, which will reduce the number of false positive detections. We will implement\na self-adapting artificial intelligence algorithms and methods based on paradigm of big data in a large-scale IoT distributed\nsystem.\n                  "), _c('br'), _vm._v(" 2. Low acquisition system uncertainty, which also affects robustness. A regular in situ auto-calibration method is crucial\nto ensure high system efficiency and long product lifetime.\n                  "), _c('br'), _vm._v(" 3. An open flexible architecture of the system that can be adapted to particular customer’s requirements.\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "text"
  }, [_c('br'), _c('br'), _c('br'), _vm._v("\n                Project value:"), _c('br'), _vm._v("\n                   3 866 129,08PLN\n                  "), _c('br'), _c('br'), _vm._v("\n                 Amount of founding from UE:"), _c('br'), _vm._v("\n                2 890 434.62PLN\n                  "), _c('br'), _c('br'), _vm._v("\n                  Period of implementation: 01.09.2021 – 31.08.2023\n                ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7afab2bf"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/BPS2.vue
// module id = 304
// module chunks = 0